import JoyTooltip from '@mui/joy/Tooltip';

const Tooltip = ({ active, title, children }) => {
  return active ? (
    <JoyTooltip
      arrow
      title={title}
      slotProps={{
        // @ts-ignore
        root: { className: 'custom-width-tooltip' },
      }}
    >
      {children}
    </JoyTooltip>
  ) : (
    children
  );
};

export default Tooltip;
